import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserPassengerList from "./user-passenger-list";
import UserPassengerListParams from "./user-passenger-list-params";

const usePassengerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserPassengerList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserPassengerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const passengerList = await userService.getPassengerList(params, signal);

      setData(passengerList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default usePassengerList;
